import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Redirect, Route } from 'react-router-dom';

import classNames from 'classnames';

import { Container } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import '../css/MainView.less';

import { register } from '../i18n';

import Auth from '../managers/AuthManager';

import { REPORT_URL_KEY } from '../services/reports/ReportConstants';

import BasicIframeModalLauncherService from '../services/BasicIframeModalLauncherService';
import GuidedTourService from '../services/GuidedTourService';
import InitService from '../services/InitService';
import LtiService from '../services/LtiService';
import ThirdPartyService from '../services/ThirdPartyService';
import UserService from '../services/UserService';

import { getStyleVar, stripNonNumeric } from '../utils';

import { ImpersonationCautionBanner } from '../components/ImpersonationCautionBanner';

const t = register('MainView');

export default
@inject(
  'accessManager', 'accommodationsManager', 'appManager', 'assignmentManager', 'classroomManager',
  'contentManager', 'dynamicSatelliteManager', 'ltiManager', 'navigationManager', 'notificationManager',
  'productManager', 'teacherProductViewManager', 'userManager')
@observer
class MainView extends Component {
  constructor(props) {
    super(props);

    this.AccommodationsView = SatCoreComponent('AccommodationsView');
    this.AdminAddTeacher = SatCoreComponent('AdminAddTeacher');
    this.AdminClassroomsView = SatCoreComponent('AdminClassroomsView');
    this.AdminContentView = SatCoreComponent('AdminContentView');
    this.AdminDashboard = SatCoreComponent('AdminDashboard');
    this.AdminProductsView = SatCoreComponent('AdminProductsView');
    this.AdminSchoolsView = SatCoreComponent('AdminSchoolsView');
    this.AdminTestBuilderView = SatCoreComponent('AdminTestBuilderView');
    this.AdminTopNav = SatCoreComponent('AdminTopNav');
    this.AdminUserProfile = SatCoreComponent('AdminUserProfile');
    this.AdminUsersView = SatCoreComponent('AdminUsersView');
    this.ArchivedClasses = SatCoreComponent('ArchivedClasses');
    this.AssessmentItemShopPanel = SatCoreComponent('AssessmentItemShopPanel');
    this.AssignmentDeepLinkHandlerView = SatCoreComponent('AssignmentDeepLinkHandlerView');
    this.AssignmentView = SatCoreComponent('AssignmentView');
    this.BasicIframeModalLauncherIcon = SatCoreComponent('BasicIframeModalLauncherIcon');
    this.CautionBanner = SatCoreComponent('CautionBanner');
    this.CautionBannerObserver = SatCoreComponent('CautionBannerObserver');
    this.ClassCourses = SatCoreComponent('ClassCourses');
    this.ClassDetails = SatCoreComponent('ClassDetails');
    this.ClassRoster = SatCoreComponent('ClassRoster');
    this.ClassSettingsView = SatCoreComponent('ClassSettingsView');
    this.ClassWorkspace = SatCoreComponent('ClassWorkspace');
    this.Dashboard = SatCoreComponent('TeacherDashboard');
    this.DialogList = SatCoreComponent('DialogList');
    this.EditStudentProfile = SatCoreComponent('EditStudentProfile');
    this.ExternalDashboard = SatCoreComponent('ExternalDashboard');
    this.GenericTopNav = SatCoreComponent('GenericTopNav');
    this.Gradebook = SatCoreComponent('Gradebook');
    this.GradedAssignmentPanel = SatCoreComponent('GradedAssignmentPanel');
    this.GroupRoster = SatCoreComponent('GroupRoster');
    this.FloatingHelpLauncher = SatCoreComponent('FloatingHelpLauncher');
    this.GuidedTourLauncher = SatCoreComponent('GuidedTourLauncher');
    this.LtiContentPickerView = SatCoreComponent('LtiContentPickerView');
    this.LtiContentPickerSearchView = SatCoreComponent('LtiContentPickerSearchView');
    this.LtiMainView = SatCoreComponent('LtiMainView');
    this.LtiTopNav = SatCoreComponent('LtiTopNav');
    this.LTIPlayerLauncher = SatCoreComponent('LTIPlayerLauncher');
    this.LearnosityPrintPreview = SatCoreComponent('LearnosityPrintPreview');
    this.NotFoundView = SatCoreComponent('NotFoundView');
    this.NotificationsView = SatCoreComponent('NotificationsView');
    this.Profile = SatCoreComponent('Profile');
    this.ProgressView = SatCoreComponent('ProgressView');
    this.PublisherAdminTopNav = SatCoreComponent('PublisherAdminTopNav');
    this.PublisherCourse = SatCoreComponent('PublisherCourse');
    this.ReportJsonDiff = SatCoreComponent('ReportJsonDiff');
    this.ReportTypeSelectorView = SatCoreComponent('ReportTypeSelectorView');
    this.ReportView = SatCoreComponent('ReportView');
    this.ResourcesView = SatCoreComponent('ResourcesView');
    this.RoleSwitcherView = SatCoreComponent('RoleSwitcherView');
    this.SatCoreLoader = SatCoreComponent('SatCoreLoader');
    this.SatelliteTab = SatCoreComponent('SatelliteTab');
    this.StudentAssignmentTilesView = SatCoreComponent('StudentAssignmentTilesView');
    this.StudentAssignmentView = SatCoreComponent('StudentAssignmentView');
    this.StudentCourseLandingView = SatCoreComponent('StudentCourseLandingView');
    this.StudentDashboard = SatCoreComponent('StudentDashboard');
    this.StudentTopNav = SatCoreComponent('StudentTopNav');
    this.TeacherProductView = SatCoreComponent('TeacherProductView');
    this.TeacherTestBuilderView = SatCoreComponent('TeacherTestBuilderView');
    this.ThirdPartyChatLauncher = SatCoreComponent('ThirdPartyChatLauncher');
    this.TopNav = SatCoreComponent('TopNav');
    this.TrialBanner = SatCoreComponent('TrialBanner');
    this.Verification = SatCoreComponent('Verification');
  }

  async componentDidMount() {
    const { ltiManager, navigationManager, userManager } = this.props;
    const urlParams = new URLSearchParams(window.location.search);

    if (window.location.pathname === '/lti-courses') {
      console.info('[MainView] LTI landing url', window.location.href, Object.fromEntries(urlParams));
      // Initial LTI launch from backend - parse params and initialize
      ltiManager.setIsLtiLoading(true);
      await LtiService.initLtiMainViewContext(urlParams);
      await userManager.trackLoggedIn();
      ltiManager.setIsLtiLoading(false);
    } else if (ltiManager.isLti) {
      // LTI context already active (refresh) - restore state from sessionStorage
      ltiManager.setIsLtiLoading(true);
      await InitService.initData(urlParams);

      // Verify user is still authorized for LTI access
      if (!Auth.loggedIn() || !userManager.hasTeacherPermission) {
        ltiManager.setIsLtiUnauthorized(true);
        ltiManager.setIsLtiLoading(false);
        return;
      }

      await userManager.trackLoggedIn();
      ltiManager.setIsLtiLoading(false);

      // Set view from URL param if present
      const view = urlParams.get('view');
      if (view) {
        navigationManager.setView(view);
      }
    } else {
      // Regular (non-LTI) initialization
      InitService.doLoginInit();
      await InitService.initData(urlParams);
      await userManager.trackLoggedIn();
    }
  }

  getAccessRedirects = () => {
    const {
      accessManager: {
        policies: { mainView: { classDetails, classCourses, resourcesView, assignmentView, studentAssignmentView, progressView } }
      },
      userManager: { isStudent }
    } = this.props;

    return isStudent ? (
      <>
        {!classCourses && <Redirect path='/courses' to='/' />}
        {!classDetails && <Redirect path='/class' to='/' />}
        {!resourcesView && <Redirect exact path='/resources' to='/' />}
        {!assignmentView && <Redirect exact from='/assignments' to='/' />}
        {!studentAssignmentView && <Redirect exact path='/student-assignments' to='/' />}
        {!progressView && <Redirect exact path='/progress' to='/' />}
      </>
    ) : null;
  };

  buildCautionBannerMsgConfigArray = ({
    isReadOnlyGradebook,
    shouldShowExpiredLicenseWarning,
    shouldShowNotificationBanner
  }) => {
    const cautionBannerMsgConfigArray = [];

    if (shouldShowExpiredLicenseWarning) {
      cautionBannerMsgConfigArray.push({
        _id: 'expiredLicenseCautionBannerMsg',
        translationKey: 'expiredLicenseCautionBannerMsg'
      });
    }

    if (isReadOnlyGradebook) {
      cautionBannerMsgConfigArray.push({
        _id: 'readOnlyGradebookCautionBannerMsg',
        translationKey: 'readOnlyGradebookCautionBannerMsg'
      });
    }

    if (shouldShowNotificationBanner) {
      cautionBannerMsgConfigArray.push({
        _id: 'notificationCautionBannerMsg',
        translationKey: 'notificationCautionBannerMsg'
      });
    }

    return cautionBannerMsgConfigArray;
  };

  getRoutes = () => {
    const {
      appManager, ltiManager, teacherProductViewManager, userManager
    } = this.props;

    const {
      isDistrictOrSchoolAdmin,
      isDistrictOrSchoolAssessmentAdmin,
      isProductAdmin,
      isSsoUser,
      isStudent,
      isTeacher
    } = userManager;

    const { isLti } = ltiManager;

    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.getRoutes !== undefined) {
      // eslint-disable-next-line react/destructuring-assignment
      return this.props.getRoutes(this.props, this);
    }
    const Dashboard = this.getDashboard();

    const {
      AccommodationsView, AdminAddTeacher, AdminClassroomsView, AdminContentView, AdminProductsView,
      AdminUserProfile, AdminUsersView, ArchivedClasses, AssignmentView, ClassCourses, ClassDetails, ClassRoster,
      AssignmentDeepLinkHandlerView, ClassSettingsView, ClassWorkspace, EditStudentProfile, ExternalDashboard, Gradebook,
      GroupRoster, LTIPlayerLauncher, LearnosityPrintPreview, NotificationsView, Profile, ProgressView, PublisherCourse,
      ReportJsonDiff, ResourcesView, RoleSwitcherView, StudentAssignmentTilesView, StudentAssignmentView,
      StudentCourseLandingView, TeacherProductView, Verification
    } = this;

    let adminRoutes = <></>;
    if (isDistrictOrSchoolAdmin) {
      adminRoutes = (
        <>
          <Route component={AdminAddTeacher} path='/adminAddTeacher' />
          <Route component={AdminUserProfile} path='/adminProfile' />
          <Route component={AdminUsersView} path='/users' />
          <Route component={AdminClassroomsView} path='/classrooms' />
          {this.getAdminReportRoutes()}
        </>
      );
    }
    let adminOrAdminProductRoutes = <></>;
    if (isDistrictOrSchoolAdmin || isDistrictOrSchoolAssessmentAdmin || isProductAdmin) {
      adminOrAdminProductRoutes = (
        <>
          {userManager.canViewSatelliteContent && (
            <Route component={AdminContentView} path='/content' />
          )} {/* my/shared, live */}
          {userManager.canViewSatelliteProducts && (
            <Route component={AdminProductsView} path='/products' />
          )}
          {this.getAdminTestBuilderRoutes()}
        </>
      );
    }
    let adminOrTeacherRoutes = <></>;
    if (isDistrictOrSchoolAdmin || isTeacher) {
      const { accommodationsManager } = this.props;
      adminOrTeacherRoutes = (
        <>
          {accommodationsManager.includeClassroomAccommodations && <Route component={AccommodationsView} path='/accommodations' />}
          <Route component={EditStudentProfile} exact path='/editStudentProfile' />
          <Route component={ClassRoster} path='/roster' />
          <Route component={ClassSettingsView} path='/settings' />
          <Route component={GroupRoster} path='/groups' />
          {this.getAdminOrTeacherReportRoutes()}
          {this.getTeacherTestBuilderRoutes()}
        </>
      );
    }

    return (
      <>
        <main className='main-view-routes' role='main'>
          {this.getAccessRedirects()}
          <Route component={Dashboard} exact path='/' />

          {!isLti && (
            <>
              {isTeacher && <Route component={ArchivedClasses} exact path='/archived-classes' />}

              {isStudent && (
                <Route component={StudentCourseLandingView} path='/student-book-courses' />
              )}

              <Route component={ExternalDashboard} path='/externalDashboard' />

              <Route component={ClassDetails} path='/class' />

              <Route component={ClassCourses} path='/courses' />
              <Route component={ResourcesView} exact path='/resources' />
              <Route component={AssignmentView} exact path='/assignments' />
              <Route component={StudentAssignmentTilesView} exact path='/student-assignment-tiles' />
              <Route component={StudentAssignmentView} exact path='/student-assignments' />
              {appManager.classWorkspaceFeature && <Route component={ClassWorkspace} exact path='/workspace' />}
              {(isDistrictOrSchoolAdmin || isTeacher) && (<Route component={Gradebook} exact path='/gradebook' />)}

              {isTeacher && userManager.allowTeacherLibraryContentView && (
                <Route component={AdminContentView} path='/content' />
              )}

              {isTeacher && teacherProductViewManager.allowTeacherProductView && (
                <Route component={TeacherProductView} path='/products' />
              )}

              {(isTeacher && !isDistrictOrSchoolAdmin && !isProductAdmin) && (
                <Route component={LearnosityPrintPreview} path='/lrnPrint' />
              )}

              <Route component={PublisherCourse} exact path='/publisherCourse' />
              {(isStudent) && (<Route component={ProgressView} path='/progress' />)}
            </>
          )}

          <Route component={Profile} exact path='/profile' />
          <Route component={Verification} exact path='/verification' />

          {/* all users except students get notifications Route */}
          {(!isStudent) && (<Route component={NotificationsView} path='/notifications' />)}

          <Route component={ReportJsonDiff} exact path='/reportJsonDiff' />
          <Route component={LTIPlayerLauncher} exact path='/ltiPlayer' />
          <Route component={AssignmentDeepLinkHandlerView} exact path='/launch' />

          {/* LTI Routes */}
          <Route component={this.LtiContentPickerView} exact path='/lti-courses' />
          <Route component={this.LtiContentPickerView} exact path='/ltiContentPicker' />
          <Route component={this.LtiContentPickerSearchView} exact path='/ltiContentPickerSearch' />

          {adminOrTeacherRoutes}
          {adminRoutes}
          {adminOrAdminProductRoutes}

          <Route component={RoleSwitcherView} exact path='/switch-role' />

          {/* TODO uncomment to redirect user to 404 landing page if route (pathname) is not recognized */}
          {/* TODO needs testing - commenting out for now as it appears to cause issues for some cases */}
          {/* catch-all for unmatched routes (pathnames) */}
          {/* <Route component={this.NotFoundView} path='*' /> */}
        </main>
      </>
    );
  }

  getAdminReportRoutes = (basePath = '') => {
    const { ReportView } = this;
    return (
      <>
        {/* COURSE DISTRICT REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-district-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-district-detail']}`} />
        {/* COURSE SCHOOL REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-school-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-school-detail']}`} />
        {/* STANDARDS DISTRICT REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-district-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-district-detail']}`} />
        {/* STANDARDS SCHOOL REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-school-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-school-detail']}`} />
      </>
    );
  };

  getAdminOrTeacherReportRoutes = (basePath = '') => {
    const { ReportTypeSelectorView, ReportView } = this;
    return (
      <>
        {/* REPORTS */}
        <Route component={ReportTypeSelectorView} exact path={`${basePath}/reports`} />
        {/* COURSE CLASSROOM/INDIVIDUAL REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-classroom-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-classroom-detail']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/course-classroom-individual']}`} />
        {/* STANDARDS CLASSROOM/INDIVIDUAL REPORTS */}
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-classroom-summary']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-classroom-detail']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-classroom-detail-students']}`} />
        <Route component={ReportView} exact path={`${basePath}${REPORT_URL_KEY['/reports/standards-classroom-individual']}`} />
      </>
    );
  };

  getAdminTestBuilderRoutes = (basePath = '') => {
    const { userManager } = this.props;
    const { AdminTestBuilderView } = this;
    const { isDistrictOrSchoolAdmin, isDistrictOrSchoolAssessmentAdmin } = userManager;
    return (
      <>
        {/* ADMIN TEST BUILDER */}
        {userManager.canViewSatelliteTestBuilder && (isDistrictOrSchoolAdmin || isDistrictOrSchoolAssessmentAdmin) && (
          <Route component={AdminTestBuilderView} path={`${basePath}/adminTestbuilder`} />
        )}
      </>
    );
  };

  getTeacherTestBuilderRoutes = (basePath = '') => {
    const { userManager } = this.props;
    const { TeacherTestBuilderView } = this;
    const { isTeacher } = userManager;
    return (
      <>
        {/* TEACHER TEST BUILDER */}
        {userManager.canViewSatelliteTestBuilder && isTeacher && (
          <Route component={TeacherTestBuilderView} path={`${basePath}/testbuilder`} />
        )}
      </>
    );
  };

  getTopNav = () => {
    const { ltiManager, productManager, userManager } = this.props;

    // LTI context - show LTI-specific top navigation
    if (ltiManager.isLti) {
      return this.LtiTopNav;
    }

    const {
      hasPublisherPermission,
      isDistrictOrSchoolAdmin,
      isDistrictOrSchoolAssessmentAdmin,
      isProductAdmin,
      isStudent,
      isTeacher
    } = userManager;
    const { isFromProduct } = productManager;

    if (isFromProduct && isFromProduct !== 'FROM_TEACHER_PRODUCTS_NAV' && hasPublisherPermission) {
      return this.PublisherAdminTopNav;
    } else if (isDistrictOrSchoolAdmin || isDistrictOrSchoolAssessmentAdmin || isProductAdmin) {
      return this.AdminTopNav;
    } else if (isTeacher) {
      return this.TopNav;
    } else if (isStudent) {
      return this.StudentTopNav;
    } else {
      return this.GenericTopNav;
    }
  }

  getDashboard = () => {
    const {
      getDashboard: getDashboardProp,
      history,
      userManager
    } = this.props;

    // Allow prop override for custom dashboard (e.g., LTI)
    if (typeof getDashboardProp === 'function') {
      return getDashboardProp(this.props, this);
    }
    const {
      activePermissionId,
      isDistrictOrSchoolAdmin,
      isDistrictOrSchoolAssessmentAdmin,
      isProductAdmin,
      isTeacher,
      loaded
    } = userManager;

    if (!loaded) {
      return null;
    }
    if (!activePermissionId) {
      UserService.showRoleSwitcher(history);
      return this.RoleSwitcherView;
    }

    if (isDistrictOrSchoolAdmin || isDistrictOrSchoolAssessmentAdmin || isProductAdmin) {
      return this.AdminDashboard;
    } else if (isTeacher) {
      return this.Dashboard;
    } else {
      return this.StudentDashboard;
    }
  }

  renderTrialBanner() {
    const { TrialBanner } = this;
    const { appManager, userManager } = this.props;
    return appManager.trialFeature && userManager.isLicensedByPurchaseCode ? <TrialBanner /> : null;
  }

  render() {
    const {
      appManager,
      classroomManager,
      contentManager,
      dynamicSatelliteManager,
      getNavTabs,
      ltiManager,
      navigationManager,
      notificationManager,
      productManager,
      setCurrentClassroomId,
      topNav,
      userManager
    } = this.props;

    // Show LtiMainView for unauthorized LTI users
    if (ltiManager.isLti && ltiManager.isLtiUnauthorized) {
      const { LtiMainView } = this;
      return <LtiMainView message={t('unauthorized')} />;
    }

    const {
      AssessmentItemShopPanel,
      BasicIframeModalLauncherIcon,
      CautionBanner,
      CautionBannerObserver,
      GradedAssignmentPanel,
      SatelliteTab
    } = this;

    const { isStudent } = userManager;

    const TopNav = this.getTopNav();

    if (!userManager.isImpersonatorAdmin) {
      if (sessionStorage.getItem('impersonate')) {
        userManager.setIsImpersonatorAdmin(true);
      }
    }

    // This code pattern seems a little verbose and boiler-plate
    // but this is the only way to ensure that a new component isn't created
    // every time render is called and this also ensures the 'this' pointer
    // is not corrupted as the component tree gets large.
    const { DialogList, FloatingHelpLauncher, GuidedTourLauncher, SatCoreLoader, ThirdPartyChatLauncher } = this;

    const shouldAllowGuidedTourLauncher = GuidedTourService.shouldAllowGuidedTourLauncher();
    const shouldAllowThirdPartyChatLauncher = ThirdPartyService.shouldAllowThirdPartyChatLauncherForActiveUser();

    const shouldShowExpiredLicenseWarning = productManager.shouldShowExpiredLicenseWarning && (
      !userManager.isStudent || productManager.allowShowExpiredLicenseWarningForStudent
    );

    // Currently not showing notification banner to students.
    const { shouldShowNotificationBanner } = notificationManager;

    const pathname = appManager.location?.pathname || window.location.pathname;
    const isReadOnlyGradebook = userManager.isDistrictOrSchoolAdmin && (
      pathname?.includes?.('gradebook')
    );

    // Build the caution banner message configuration array.
    // Note that ImpersonationCautionBanner is separate from this, and will be rendered **above** CautionBanner if applicable.
    const cautionBannerKey = 'DefaultCautionBanner';
    const shouldShowNotificationBannerForNonStudents = shouldShowNotificationBanner && !userManager.isStudent;
    const cautionBannerMsgConfigArray = this.buildCautionBannerMsgConfigArray({
      isReadOnlyGradebook,
      shouldShowExpiredLicenseWarning,
      shouldShowNotificationBanner: shouldShowNotificationBannerForNonStudents
    });

    const shouldShowGenericCautionBannerComponent = cautionBannerMsgConfigArray.length > 0;
    const hasCautionBanner = userManager.isImpersonatorAdmin || shouldShowGenericCautionBannerComponent;

    const navSeparator = (
      <div className={classNames(`nav-separator ${navigationManager.viewSelection}`, {
        'nav-separator-top': hasCautionBanner
      })} />
    );

    const topNavHeight = +stripNonNumeric(getStyleVar('--caution-banner-nav-height') || 0);
    const navSeparatorHeight = +stripNonNumeric(getStyleVar('--caution-banner-nav-separator-height') || 0);
    const impersonationCautionBannerMinHeight = +stripNonNumeric(getStyleVar('--impersonation-caution-banner-min-height') || 0);

    const cautionBannerStickyOffset = (
      topNavHeight + navSeparatorHeight + (userManager.isImpersonatorAdmin ? impersonationCautionBannerMinHeight : 0)
    );

    const isLoadingDynamicSatelliteCss = (
      dynamicSatelliteManager.isDynamicSatellite && !dynamicSatelliteManager.isDynamicSatelliteCssLoaded
    );
    const loaded = (
      classroomManager.loaded && userManager.loaded && !(ltiManager.isLti && ltiManager.isLtiLoading) && !isLoadingDynamicSatelliteCss
    );
    const childComponent = (isStudent) ? GradedAssignmentPanel : AssessmentItemShopPanel;
    const tabName = (isStudent) ? 'Previous Assignments' : 'Related Content';

    const iframeModalLauncherObj = (
      BasicIframeModalLauncherService.getFloatingHelpIframeLauncherMapEntryValue()
    );
    const allowFloatingHelpIframeModalLauncher = BasicIframeModalLauncherService.allowFloatingHelpIframeModalLauncher(
      iframeModalLauncherObj
    );

    const floatingHelpModalHeaderTitle = t(`floatingHelpModalHeaderTitle_${iframeModalLauncherObj?._id}`);

    return (loaded ? (
      <>
        {!ltiManager.isLti && (
          <>
            {shouldAllowGuidedTourLauncher && <GuidedTourLauncher />}
            {shouldAllowThirdPartyChatLauncher && <ThirdPartyChatLauncher />}

            {!!allowFloatingHelpIframeModalLauncher && (
              <>
                <FloatingHelpLauncher
                  headerTitle={floatingHelpModalHeaderTitle}
                  iframeModalLauncherObj={iframeModalLauncherObj} />
                <BasicIframeModalLauncherIcon
                  headerTitle={floatingHelpModalHeaderTitle}
                  iframeModalLauncherObj={iframeModalLauncherObj} />
              </>
            )}

            <SatelliteTab ChildComponent={childComponent} tabName={tabName} />
          </>
        )}
        <DialogList />
        <Container
          className={classNames('fullHeight main-view', {
            'hidden': contentManager.hideContentPanel,
            'student-client': isStudent
          })}
          fluid>
          <TopNav
            additionalClassName={!userManager.activePermissionId ? 'no-role' : ''}
            getNavTabs={getNavTabs}
            setCurrentClassroomId={setCurrentClassroomId}
            {...topNav} />
          <CautionBannerObserver hasCautionBanner={hasCautionBanner} />
          {hasCautionBanner && navSeparator}

          {(userManager.isImpersonatorAdmin) && <ImpersonationCautionBanner />}
          {shouldShowGenericCautionBannerComponent && (
            <CautionBanner
              allowMinimizeMaximize={true}
              bannerKey={cautionBannerKey}
              cautionBannerMsgConfigArray={cautionBannerMsgConfigArray}
              isImpersonationCautionBannerShowing={userManager.isImpersonatorAdmin}
              stickyOffset={cautionBannerStickyOffset} />
          )}
          {/* TODO remove */}
          {/* {isReadOnlyGradebook && (
            <CautionBanner bannerKey='ReadOnlyGradebookCautionBanner' cautionBannerMsg={t('readOnlyGradebookCautionBannerMsg')}
              stickyOffset={cautionBannerStickyOffset + (shouldShowExpiredLicenseWarning ? 50 : 0)} />
          )} */}
          <Container className={classNames('content-area', userManager.activePermissionId)}
            fluid id='main-content' tabIndex={0}>
            {!hasCautionBanner && navSeparator}

            {this.renderTrialBanner()}
            {this.getRoutes()}
          </Container>

        </Container>
      </>
    ) :
      <SatCoreLoader />
    );
  }
}

SatCoreRegister('MainView', MainView);
